import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { TrackingsService } from '../../../services/tracking.service';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { RegularNoteComponent } from './components/regular-note/regular-note.component';
import { SinacorNoteComponent } from './components/sinacor-note/sinacor-note.component';
import { TypeNote } from './enums/typeNote.enum';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'tradingnote-aside-panel',
    templateUrl: './tradingnote-aside-panel.component.html',
    styleUrls: ['./tradingnote-aside-panel.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TradingnoteAsidePanelComponent extends DialogPanelComponentContent {
    public action: string = '';

    public constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        @Inject(DOCUMENT) private document: Document,
        public elementRef: ElementRef,
        private dialogReference: MatDialogRef<TradingnoteAsidePanelComponent>,
        private router: Router,
        private tracking: TrackingsService,
        private dialogsService: DialogsService,
    ) {
        super(elementRef, true);
        this.document.body.classList.add('freeze');
    }

    
    public clickOption(option: string){
        this.action = option;
    }

    public dateStepTradingNote() {
        this.closeDialog();
        switch (this.action) {
            case TypeNote.regular: 
                this.tracking.sendMetricsToMixpanel(ActionEventsEnum.USER_CLICKED, {element: 'Comprovantes Toro'})
                this.dialogsService.showComponentAsAsidePanel(RegularNoteComponent, true); 
                break;
            case TypeNote.sinacor: 
                this.tracking.sendMetricsToMixpanel(ActionEventsEnum.USER_CLICKED, {element: 'Nota Sinacor'})
                this.dialogsService.showComponentAsAsidePanel(SinacorNoteComponent, true); 
                break;
            default: break;
        }
    }

    /**
     * Encerra componente, habilita overflow e destroi dialogReference
     */
    public closeDialog() {
        this.document.body.classList.remove('freeze');
        this.close(this.dialogReference, null);
        this.dialogReference = null;
        this.router.navigateByUrl('/meus-investimentos');
    }
}
